import {
  APP_CATEGORY_ROUTE,
  APP_USER_VALIDATE_EMAIL_ROUTE,
  APPROVAL_DASHBOARD,
  BUY_AGAIN,
  BUY_AGAIN_EXTERNAL,
  MULTIPLE_SHOPPING_LIST,
  NUMBER_0,
  ORDER_HISTORY_LINK_EXTERNAL,
  SHOPPING_LIST_V2,
} from '~shared/constants';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import * as fromHeader from '../../../../store';
import { Observable, Subject, combineLatest, of } from 'rxjs';
import { getCategories } from '../../../../store';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { APP_ALL_OFFERS_ROUTE, APP_LANDING_PAGE_ROUTE, FeatureToggleEnum } from '~shared/constants';
import { CategoriesNavbarApplicationEventHandler } from '~app/modules/generic/helpers';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { TranslateService } from '@ngx-translate/core';
import { PROMO_CATEGORIES_ID, TOP_MENU_PROMOTION_LINK_ID } from '~app/modules/generic/constants/promo-constants';
import { CategoriesService } from '~app/modules/generic/services/categories.service';
import * as fromStoryblok from '~app/modules/storyblok/store';
import { StoryData } from 'storyblok-js-client';
import { TopMenuPromotionLinkBlok } from '~app/modules/storyblok/models/storyblok-global-content.model';
import { GA4GeneralApplicationEvent, OrderHistoryApplicationEvent } from '~shared/modules/application-event/models';
import {
  GaTrackingEventAction,
  GaTrackingEventCategory,
  GaTrackingEventName,
  GATrackingEventType,
} from '~shared/modules/ga-tracking/constants';
import { Router } from '@angular/router';
import { Category } from '~app/modules/generic/models';
import { animate, style, transition, trigger } from '@angular/animations';
import { RegionSelectorService } from '~shared/modules/region-selector/services';
import { AccountTypeInfo, IAccountInformation } from '~shared/models';
import { environment } from '~env/environment';
import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';

interface topMenuPromotionCategory extends Category {
  storyBlokEditable: string;
}

@Component({
  selector: 'app-mobile-parent-categories-navigation',
  templateUrl: './mobile-parent-categories-navigation.component.html',
  styleUrls: ['./mobile-parent-categories-navigation.component.scss'],
  animations: [
    trigger('categoryListAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('0.2s ease-in-out', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition(':leave', [animate('0.2s ease-in-out', style({ transform: 'translateX(-100%)', opacity: 0 }))]),
    ]),
    trigger('childCategoryListAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('0.2s ease-in-out', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition(':leave', [animate('0.2s ease-in-out', style({ transform: 'translateX(100%)', opacity: 0 }))]),
    ]),
  ],
})
export class MobileParentCategoryNavigationComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isMenuOpened: boolean;
  @Input() user: IAccountInformation;
  private destroySubject$ = new Subject<boolean>();
  private applicationEventHandler: CategoriesNavbarApplicationEventHandler;

  categories: Array<Category>;
  childCategories: Array<Category>;
  isAllOffersFFEnabled$: Observable<boolean>;
  promoCategory: Category;
  selectedCategory: Category;
  topMenuPromotionLink: topMenuPromotionCategory;
  isTopCategoryView = true;
  isNewMenuBarEnabledV2: Observable<boolean>;
  isMultipleShoppingListEnabled: Observable<boolean>;
  showApprovalDashboard: boolean;
  isApprovalDashboardFFEnabled$ = this.featureFlagService.isFeatureEnabledAndReadyV2(
    FeatureToggleEnum.FF_BOE_HEADER_APPROVALS_DASHBOARD_LINK
  );
  isShowingOrdersHistoryLink$ = this.featureFlagService.isFeatureEnabledAndReadyV2(
    FeatureToggleEnum.ODR_TMP_1722_HEADER_SHOW_ORDERS_INSTEAD_OF_BUY_AGAIN
  );
  readonly allOffersRoute = [`/${APP_LANDING_PAGE_ROUTE}/${APP_ALL_OFFERS_ROUTE}`];
  readonly buyAgainLink = BUY_AGAIN;
  readonly validateEmailLink = APP_USER_VALIDATE_EMAIL_ROUTE;
  readonly defaultIcon = 'apps';
  readonly categoryIcons = {
    '9e0537f6-081e-4da6-87e6-13dc3652588b': 'bussiness-types',
    '0cfdb05f-5b55-48c6-a9ca-19e6617f7149': 'cleaning',
    '1cc17afc-c78e-40f5-a0c8-b0e87b86b7ed': 'food-products',
    'e45413de-3229-40b6-be52-2f77f97bcdc2': 'cooling-technology',
    '9e0535e2-d1ea-4666-82ee-8f4b354326b0': 'furniture',
    '9e05330f-153a-4e56-800d-ca36d69bd3b3': 'kitchen-accessories',
    'a5b43858-1f40-421d-a981-1b0b9c8a4c1d': 'kitchen-equipment',
    'a343dbee-71bb-40a2-a7bb-d47f6324161d': 'logistics',
    '9721e9e7-78a6-47b6-9168-85538866fd52': 'table-setting',
    '3e18e2b2-a052-47e1-b35f-bad84ddfbbfe': 'to-go-and-disposables',
  };
  regionSelector$ = this.regionSelectorService.getActiveRegionSelector();

  constructor(
    private store: Store<fromHeader.BuyerState>,
    private featureFlagService: ActiveFeaturesConfigcatService,
    private applicationEventService: ApplicationEventService,
    private translateService: TranslateService,
    private categoriesService: CategoriesService,
    private router: Router,
    private readonly regionSelectorService: RegionSelectorService,
    private readonly accountInfoService: AccountInfoService,
    private gtmDatalayerService: GtmDatalayerService,
  ) {
    this.applicationEventHandler = new CategoriesNavbarApplicationEventHandler(
      applicationEventService,
      this.translateService
    );
  }

  ngOnInit(): void {
    this.loadFFs();
    this.loadCategories();
    this.loadPromoCategories();
    this.loadTopMenuPromotionLinkNavigationMenu();
    this.accountInfoService
      .getAccountInfoV2()
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((accountInfo) => {
        const isHeadQuarter = accountInfo?.customer?.accountType == AccountTypeInfo.HEAD_QUARTER;
        this.showApprovalDashboard = isHeadQuarter && accountInfo?.scopes?.includes('checkout:manage');
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['isMenuOpened'] || !changes['isMenuOpened'].currentValue) {
      setTimeout(() => {
        this.isTopCategoryView = true;
        this.selectedCategory = null;
      }, 200);
    }
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  private loadFFs(): void {
    this.isAllOffersFFEnabled$ = this.featureFlagService.isFeatureEnabled(FeatureToggleEnum.FF_MACO_ALL_OFFERS);
    this.isNewMenuBarEnabledV2 = this.featureFlagService.isFeatureEnabledAndReadyV2(
      FeatureToggleEnum.FF_BOE_SHOPPING_LIST
    );
    this.isMultipleShoppingListEnabled = this.featureFlagService.isFeatureEnabledAndReadyV2(
      FeatureToggleEnum.FF_BOE_MULTIPLE_SHOPPING_LIST
    );
  }

  private filterCategoriesChildren(categories: Array<Category>): Array<Category> {
    return categories.map((category) => category.children).reduce((acc, children) => acc.concat(children), []);
  }

  private loadCategories(): void {
    this.store.pipe(select(getCategories)).subscribe((categories) => {
      this.categories = categories;
      this.childCategories = this.filterCategoriesChildren(categories);
    });
  }

  private loadPromoCategories(): void {
    combineLatest(
      this.categoriesService.getPromoCategories(),
      this.translateService.get('HOME.HOME_PAGE.PROMO_CATEGORIES.PARENT_CATEGORY_TITLE')
    )
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(([promoCategories, translation]) => {
        if (promoCategories.length > NUMBER_0) {
          this.promoCategory = {
            id: PROMO_CATEGORIES_ID,
            name: translation,
            parents: [],
            children: promoCategories,
            slug: '',
          };
        }
      });
  }

  private loadTopMenuPromotionLinkNavigationMenu(): void {
    this.store
      .pipe(select(fromStoryblok.getNavigation), takeUntil(this.destroySubject$))
      .subscribe((navigationStory: StoryData) => {
        const link: TopMenuPromotionLinkBlok = navigationStory?.content?.global?.[0];
        if (link) {
          this.topMenuPromotionLink = {
            id: TOP_MENU_PROMOTION_LINK_ID,
            children: [],
            parents: [],
            slug: link.link,
            name: link.title,
            storyBlokEditable: link._editable,
          };
        }
      });
  }

  navigateToSubCategories(category: Category): void {
    this.selectedCategory = category;
    this.isTopCategoryView = false;
  }

  backToTopCategories() {
    this.isTopCategoryView = true;
    this.selectedCategory = null;
  }

  navigateToCategory(category: Category): Promise<boolean> {
    return this.router.navigate([APP_CATEGORY_ROUTE, category.slug]);
  }

  navigateToTopMenuPromotionLink(): Promise<boolean> {
    return this.router.navigateByUrl(this.topMenuPromotionLink.slug);
  }

  fireAllPromotionsClickEvent(): void {
    this.applicationEventHandler.publishSeeAllPromotion();
  }

  fireCategoryNavigationGAEvent(category: Category | topMenuPromotionCategory): void {
    this.applicationEventHandler.publishAppNavigation(category.name);
  }

  public onShoppingListClick(multipleShoppingList?: boolean): void {
    this.sendGAEventShoppingList();
    if (this.user) {
      window.location.href = `${environment.appBaseUrl()}${multipleShoppingList ? MULTIPLE_SHOPPING_LIST : SHOPPING_LIST_V2
        }`;
    } else {
      this.redirectToValidateEmailPage(multipleShoppingList ? MULTIPLE_SHOPPING_LIST : SHOPPING_LIST_V2);
    }
  }

  private sendGAEventShoppingList(): void {
    this.applicationEventService.publish(
      new GA4GeneralApplicationEvent({
        event: GaTrackingEventName.shoppingListHeaderButtonInteraction,
        gtmCustom: {
          category: GaTrackingEventCategory.ShoppingListV2,
          action: GaTrackingEventAction.ShoppingListHeader,
          GA_eventname: GaTrackingEventName.Interaction,
        },
        label: null,
      })
    );
  }

  public onBuyAgainLinkClick(): void {
    this.fireBuyAgainGAEvent();
    if (this.user) {
      window.location.href = BUY_AGAIN_EXTERNAL();
    } else {
      this.redirectToValidateEmailPage(BUY_AGAIN);
    }
  }

  public onOrdershistoryLinkClick(): void {
    this.sendGAEventOrdershistory()
    window.location.href = ORDER_HISTORY_LINK_EXTERNAL();
  }

  public onApprovalDashboardLinkClick(): void {
    this.sendGAEventApprovalDashboard();
    window.location.href = `${environment.appBaseUrl()}${APPROVAL_DASHBOARD}`;
  }

  fireBuyAgainGAEvent(): void {
    this.applicationEventService.publish(
      new OrderHistoryApplicationEvent({
        event: GaTrackingEventName.BuyAgainHeaderInteraction,
        action: GaTrackingEventAction.BuyAgainHeader,
        label: null,
      })
    );
  }
  private redirectToValidateEmailPage(url: string) {
    this.router.navigate([this.validateEmailLink], {
      queryParams: { backUrl: url },
    });
  }

  private sendGAEventApprovalDashboard(): void {
    this.applicationEventService.publish(
      new GA4GeneralApplicationEvent({
        event: GaTrackingEventName.ApprovalsHeaderLinkClick,
        gtmCustom: {
          category: GaTrackingEventCategory.Interaction,
          action: GaTrackingEventAction.ApprovalDashboardHeader,
          GA_eventname: GaTrackingEventName.ApprovalsHeaderLinkClick,
        },
        label: null,
      })
    );
  }

  private sendGAEventOrdershistory(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.OrdersHistoryHeaderLinkClick,
      GA_eventname: GaTrackingEventName.Interaction,
      action: GaTrackingEventAction.OrdersHistoryHeaderLinkClick,
      category: GaTrackingEventCategory.OrdersHistory,
      label: null,
    });
  }
}
